_ = require('lodash')

angular.module('workflow.app')

.factory( 'SpellingVariations', ( Model ) ->

  class SpellingVariations extends Model
    init: () ->
      # find the links between nodes to form chains
      links = {}
      for itr in @iterations
        links[itr.id] =
          id: itr.id
          parent: itr.parent
          children: []
          object: itr
      for itr in @iterations
        if itr.parent
          links[itr.parent].children.push(itr.id)

      child_finder = (parent) ->
        ChildLeafs = []
        for child in parent.children
          linkChild = links[child]
          ChildLeafs = ChildLeafs.concat(child_finder(linkChild))
        ChildLeafs.push(parent.object)
        return ChildLeafs

      # find the begin of the chains and then find all of their children
      @spellingVariations = {}
      for itr in @iterations
        if not itr.parent
          childItrs = child_finder(links[itr.id])
          childItrs.sort (a, b) ->
            a.id - b.id
          @spellingVariations[itr.id] = childItrs

    ensureHasIteration: (iteration) ->
      existing = _.any(@iterations, {'id': iteration.id})
      if not existing
        @iterations.push(iteration)
        @init()

    getParentIterations: ->
      iterations = (i[0] for k, i of @spellingVariations)
      iterations.sort (a, b) ->
        +(a.query.toLowerCase() > b.query.toLowerCase()) or +(a.query.toLowerCase() is b.query.toLowerCase()) - 1
      iterations

    getLatestIterationForId: (id) ->
      itrs = @getIterationsForId(id)
      return itrs[itrs.length - 1]

    getIterationsForId: (id) ->
      ret = []
      for key, iterations of @spellingVariations
        if (iteration for iteration in iterations when iteration.id == parseInt(id)).length > 0
          ret = iterations
      ret

    getResultCountForId: ( id ) ->
      total = 0
      allUndefined = true
      for iteration in @getIterationsForId( id )
        if iteration.total_results?
          total = total + iteration.total_results
          allUndefined = false
      if allUndefined
        return undefined
      else
        return total

)
